import { render, staticRenderFns } from "./DiskSdChart.vue?vue&type=template&id=8599ed3e&scoped=true&"
import script from "./DiskSdChart.vue?vue&type=script&lang=js&"
export * from "./DiskSdChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8599ed3e",
  null
  
)

export default component.exports